import { useQuery } from "@tanstack/react-query"
import { microFrontendApi } from "@/shared/api/microFrontendApi/microFrontendApi"
import type { MicroFrontendUrl } from "@/shared/types/MicroFrontendUrl"

const QUERY_KEY = "microFrontendUrls"

export const useMicroFrontendUrls = () => {
  const { data, refetch, isLoading } = useQuery<MicroFrontendUrl[]>({
    queryKey: [QUERY_KEY],
    queryFn: () => microFrontendApi.getMicroFrontendUrls(),
    placeholderData: (prev?: MicroFrontendUrl[]) => prev
  })
  return { data, refetch, isLoading }
}

export const useMicroFrontendUrl = (microFrontendId = "") => {
  const { refetch, isLoading, data } = useMicroFrontendUrls()
  const microFrontendUrls = data
  const microfrontendUrl = microFrontendUrls?.find((url: MicroFrontendUrl) => url.path === microFrontendId)
  const error =
    !microfrontendUrl && !isLoading ? new Error(`Microfrontend URL not found for id: ${microFrontendId}`) : null
  return { refetch, isLoading, data: microfrontendUrl, error }
}
